const GET_USER = "/user/get-user";

const GET_USERS = "/user/get-users";

const GET_REFERRAL_DRIVERS = "/user/get-referral-drivers";

const UPDATE_USER = "/user/update-user";

const GET_PROFILE_STATUS = "/user/get-profile-status";

const COMPLETE_DRIVER_PROFILE = "/user/complete-driver-profile";

const COMPLETE_PROFILE = "/user/complete-profile";

const GET_RIDER_DETAILS = "/user/get-user";

const VERIFY_DRIVER_AND_CONNECT_WITH_RIDER =
  "/user/verify-driver-connect-with-rider";

const GET_USER_EARNINGS = "/user";

const GET_USER_DETAILS = "/user/get-user-details";

const GET_SERVICE_SUMMARY = "/user/get-service-summary";

const UPDATE_PAYMENT_METHOD = "/user/update-payment-method";

const VALIDATE_USER_BLOCKED = "/user/validate-user-blocked";

const MARK_PWA_INSTALLED = "/user/mark-pwa-installed";

const MARK_TERMS_SEEN = "/user/terms-seen";

export {
  GET_USER,
  GET_USERS,
  GET_REFERRAL_DRIVERS,
  UPDATE_USER,
  GET_PROFILE_STATUS,
  COMPLETE_DRIVER_PROFILE,
  VERIFY_DRIVER_AND_CONNECT_WITH_RIDER,
  COMPLETE_PROFILE,
  GET_RIDER_DETAILS,
  GET_USER_EARNINGS,
  GET_USER_DETAILS,
  GET_SERVICE_SUMMARY,
  UPDATE_PAYMENT_METHOD,
  VALIDATE_USER_BLOCKED,
  MARK_PWA_INSTALLED,
  MARK_TERMS_SEEN,
};
